import { z } from 'zod';
import { objectIdStr } from './common.js';
import { stationKey } from './station.js';

/** Roles replace the old numeric `privilege`. Ordered, least to most. */
export const ROLES = ['viewer', 'operator', 'planner', 'admin'] as const;
export type Role = (typeof ROLES)[number];
export const role = z.enum(ROLES);

const RANK: Record<Role, number> = { viewer: 0, operator: 1, planner: 2, admin: 3 };

/** True when `actual` is at least as privileged as `required`. */
export function roleAtLeast(actual: Role, required: Role): boolean {
  return RANK[actual] >= RANK[required];
}

export const user = z.object({
  _id: objectIdStr,
  email: z.string().email(),
  role,
  /** Lets a scan be attributed to a station automatically. */
  stationKey: stationKey.optional(),
  department: z.string().optional(),
  color: z.string().optional(),
});
export type User = z.infer<typeof user>;

export const userWrite = z.object({
  email: z.string().email(),
  role,
  stationKey: stationKey.optional().nullable(),
  department: z.string().optional(),
  color: z.string().optional(),
});
export type UserWrite = z.infer<typeof userWrite>;

export const meResponse = z.object({
  email: z.string().email(),
  role,
  stationKey: stationKey.optional(),
  department: z.string().optional(),
  color: z.string().optional(),
  displayName: z.string().optional(),
});
export type MeResponse = z.infer<typeof meResponse>;
